module.exports = __webpack_public_path__ + "media/images/recruit/credo/img-mantle-b03123aec9ae4dd67ca979e1e2ad74c4.svg";